import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ENV_CONFIG } from '@ps/core-config';

import { SsoApi } from '../api/sso.api';
import { SsoCheckContextResult, SsoOidcConfig } from '../models/sso.model';
import { User } from '../models/user.model';

@Injectable({ providedIn: 'root' })
export class SsoService {
  private readonly _api = inject(SsoApi);
  private readonly _env = inject(ENV_CONFIG);

  public checkContext(email: string): Observable<SsoCheckContextResult> {
    return this._api.checkContext(email);
  }

  public exchangeCode(code: string): Observable<User> {
    return this._api.exchangeCode(code);
  }

  public buildOidcAuthUrl(config: SsoOidcConfig, email: string): string {
    const params = new URLSearchParams({
      client_id: config.clientId,
      response_type: config.responseType,
      scope: config.scope,
      redirect_uri: config.redirectUri,
      login_hint: email,
    });
    return `${this._env.authUrl}/oidc/auth?${params.toString()}`;
  }

  public buildOidcLogoutUrl(origin: string): string {
    return `${this._env.authUrl}/oidc/session/end?post_logout_redirect_uri=${origin}/oidc`;
  }
}
